import dateFormat from 'dateformat';

const DATE_FORMAT = 'yyyy-mm-dd';

export function isSameDay(day1, day2) {
  return dateFormat(day1, DATE_FORMAT) === dateFormat(day2, DATE_FORMAT);
}

function getEasterSunday(year) {
  const f = Math.floor;
  const G = year % 19;
  const C = f(year / 100);
  const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
  const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
  const J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
  const L = I - J;
  const month = 3 + f((L + 40) / 44);
  const day = L + 28 - 31 * f(month / 4);

  return new Date(year, month - 1, day);
}

function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function isPublicHoliday(date) {
  const year = date.getFullYear();

  const fixedHolidays = [
    new Date(year, 0, 1),
    new Date(year, 0, 6),
    new Date(year, 4, 1),
    new Date(year, 4, 3),
    new Date(year, 7, 15),
    new Date(year, 10, 1),
    new Date(year, 10, 11),
    new Date(year, 11, 24),
    new Date(year, 11, 25),
    new Date(year, 11, 26),
  ];

  const easter = getEasterSunday(year);
  const movableHolidays = [
    // Easter Monday
    addDays(easter, 1),
    // Pentecost
    addDays(easter, 49),
    // Corpus Christi
    addDays(easter, 60),
  ];

  const allHolidays = [...fixedHolidays, ...movableHolidays];

  return allHolidays.some(holiday => isSameDay(holiday, date));
}
